import { StandardProps } from "../componentMap";
import { ChannelBannerUI } from "./ChannelBannerUI";
import { DiorBannerUI } from "./DiorBannerUI";

export function BrandBanner({ product }: Pick<StandardProps, "product">) {
  const { brand } = product;

  if (brand && brand.name && brand.name.toUpperCase() === "CHANEL") {
    return <ChannelBannerUI />;
  }

  if (brand && brand.name && brand.name.toUpperCase() == "DIOR") {
    return <DiorBannerUI />;
  }

  return null;
}
